import React, { Component } from 'react';

class Footer extends Component {
    state = {  }
    render() { 
        return ( 
                <footer className="page-footer font-small blue fixed-bottom">

                <div className="footer-copyright text-center py-3">© 2021
                    <a href="/"> DSA Corp.</a>
                </div>

                </footer>
 
         );
    }
}
 
export default Footer;